export type CmsTable = 'projects' | 'experiences' | 'educations' | 'certificates'

/**
 * Builds the value of the data-mdlfy-cms attribute that makes a database text value
 * editable in place: <table>:<row id>:<column>.
 */
export const cms = (table: CmsTable, id: string, column: string): string => `${table}:${id}:${column}`
